module.exports = __webpack_public_path__ + "static/maja-a1fe2c76e5c1caac95668ad0c8840d93.jpg";